import React from "react";
import logo from "../../assets/images/IMG_4242.PNG";
import { FaEye } from "react-icons/fa";

// Spectator header — same bar as components/header/TarbaaHeader.js
// (h-[11vh], bg-background, rounded bottom) with the host controls replaced
// by the live badge + viewer count.
const SpectateHeader = ({ state, presence }) => {
  const turnTeam = (state?.teams || []).find(
    (t) => String(t.id) === String(state?.turnTeamId)
  );

  return (
    <div className="w-full">
      <div className="w-full flex flex-row items-center justify-between p-2 md:pl-4 gap-1 h-[11vh] bg-background rounded-b-2xl lg:rounded-b-3xl">
        {/* Left: live badge + viewers */}
        <div className="flex flex-row items-center gap-2">
          <span className="flex items-center gap-2 text-white px-2 py-1 lg:px-3 lg:py-2 rounded-xl border-danger border-2 font-bold text-sm md:text-base">
            <span className="w-2 h-2 md:w-3 md:h-3 rounded-full bg-danger animate-pulse" />
            <h1 className="hidden md:block">مباشر</h1>
          </span>
          <span className="flex items-center gap-2 text-white px-2 py-1 lg:px-3 lg:py-2 rounded-xl border-white border-2 font-bold text-sm md:text-base">
            <FaEye className="w-4 h-4 md:w-5 md:h-5" />
            {presence?.total || 0}
          </span>
        </div>

        {/* Game Name */}
        <div className="text-white text-lg md:text-xl font-bold text-center">
          {state?.meta?.gameName}
        </div>

        {/* Right: turn + logo */}
        <div className="flex flex-row items-center gap-2">
          {turnTeam && (
            <div className="hidden sm:flex items-center gap-2 text-white px-2 py-1 lg:px-3 lg:py-2 rounded-full border-white border-2 text-sm md:text-base">
              <h1>دور فريق: {turnTeam.name}</h1>
            </div>
          )}
          <img
            className="h-10 w-10 lg:h-16 lg:w-16 object-contain text-white"
            src={logo}
            alt="تربع"
          />
        </div>
      </div>
    </div>
  );
};

export default SpectateHeader;
